import React from 'react';
import { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

const CONTAINER_ID = 'equal-ratio';
const NEED_SHOW_DISTANCE = 16;
const EXTEND_DISTANCE = 50;
const LEFT_TOP_2_RIGHT_BOTTOM = [MODES.TOP_LEFT, MODES.BOTTOM_RIGHT];
const RIGHT_TOP_2_LEFT_BOTTOM = [MODES.TOP_RIGHT, MODES.BOTTOM_LEFT];
interface Size {
    width: number;
    height: number;
    left: number;
    top: number;
    rotate?: number;
    flipH?: number;
    flipV?: number;
}

interface EqualRatioLineProps {
    startSize: Size;
    nextSize: Size;
    scale: number;
    resizeMode: string;
    flipAtStart: any;
    rotate: number;
    newWidth: number;
    newHeight: number;
}

export default class EqualRatioLineManager extends React.Component<EqualRatioLineProps> {
    public static needShow(startSize, nextSize, resizeMode, scale): boolean {
        const { width: startWidth, height: startHeight } = startSize;
        const { width: nextWidth, height: nextHeight } = nextSize;
        const needShowMode = LEFT_TOP_2_RIGHT_BOTTOM.concat(RIGHT_TOP_2_LEFT_BOTTOM);
        // 原图形宽度为0时认为与原图形大小比例不等
        // 拉伸四角的锚点才展示
        if (startWidth === 0 || needShowMode.indexOf(resizeMode) === -1) {
            return false;
        }
        const slope = startHeight / startWidth;
        // 点到直线距离公式
        const distanceToStartLine = Math.abs(((slope * nextWidth) - nextHeight) / Math.sqrt(1 + (slope ** 2)));
        if (distanceToStartLine * scale <= NEED_SHOW_DISTANCE) {
            return true;
        }
        return false;
    }

    public equalLineContainer: SVGElement;
    public render() {
        if (!this.props.nextSize) {
            return null;
        }
        const { scale, newWidth, newHeight } = this.props;
        const { d, rotateX, rotateY } = this.getSvgAttribure(newWidth, newHeight);
        const svgStyle: any = {
            position: 'absolute',
            overflow: 'visible',
            zIndex: 2,
            width: `${newWidth * scale}px`,
            height: `${newHeight * scale}px`,
            transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
        };
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                id={CONTAINER_ID}
                // @ts-ignore
                style={svgStyle}
            >
                <path
                    stroke='#E6CF63'
                    strokeOpacity='1'
                    strokeDasharray='4 4'
                    strokeWidth='1'
                    d={d}
                    width={newWidth}
                    height={newHeight}
                ></path>
            </svg>
        );
    }

    private getSvgAttribure(newWidth, newHeight) {
        const { nextSize, resizeMode, flipAtStart } = this.props;
        let d;
        const extendDistance = EXTEND_DISTANCE;
        if (newWidth > newHeight) {
            d = `M${-extendDistance} ${-extendDistance * newHeight / newWidth} L${(newWidth) + extendDistance} ${(newHeight) + (extendDistance * newHeight / newWidth)}`;
        } else {
            d = `M${-extendDistance * newWidth / newHeight} ${-extendDistance} L${(newWidth) + (extendDistance * newWidth / newHeight)} ${(newHeight) + extendDistance}`;
        }
        let rotateY = 0;
        let rotateX = 0;
        // 添加翻转
        if (RIGHT_TOP_2_LEFT_BOTTOM.indexOf(resizeMode) > -1) {
            rotateY += 180;
        }
        if (flipAtStart.flipH !== nextSize.flipH) {
            rotateX += 180;
        }
        if (flipAtStart.flipV !== nextSize.flipV) {
            rotateY += 180;
        }
        return { rotateX, rotateY, d };
    }
}
